import App from './App.svelte';
import { initSentry } from './lib/sentry';
initSentry();
const app = new App({
    target: document.body,
});
export default app;
